import { TemplatesAnimation, useResizeBase } from "@nocios/presentation-kit";

import pages from "src/Data/DEMO_WORKFLOW";

import connectWithDispatch from "src/Hooks/connectWithDispatch";
import * as appActions from "src/Actions/appActions";
import { useEffect } from "react";
import useMaxSquareDimensions from "./Hooks/useMaxSquareDimensions";
import setCurrentPage from "src/Utils/setCurrentPage";

import Config from "src/Constants/Config";

import "./App.css";

interface AppProps {
  currentPage: number;
  muted: boolean;
  setMuted: (value: boolean) => void;
}

const App = (props: AppProps) => {
  useResizeBase();
  const { currentPage, setMuted, muted } = props;
  const { width, height } = useMaxSquareDimensions();

  const toggleMuted = () => setMuted(!muted);

  useEffect(() => {
    const pagesNoBack = [-1, 0];
    const pagesNoFoward = [-1, pages.length - 1];

    let currentIndex = pages.findIndex((page) => page.page === currentPage);

    const handleKeyUp = (event: any) => {
      if (event.key === "ArrowLeft") {
        if (pagesNoBack.includes(currentIndex)) return;
        else setCurrentPage(pages[currentIndex - 1].page);
      } else if (event.key === "ArrowRight") {
        if (pagesNoFoward.includes(currentIndex) || !pages[currentIndex + 1]) return;
        else setCurrentPage(pages[currentIndex + 1].page);
      }
    };

    window.addEventListener("keyup", handleKeyUp);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("keyup", handleKeyUp);
    };
    // eslint-disable-next-line
  }, [currentPage]);

  useEffect(() => {
    document.documentElement.style.setProperty("--width-screen", `${width}px`);
    document.documentElement.style.setProperty("--height-screen", `${height}px`);
  }, [width, height]);

  return (
    <div className="App" style={{ width, height }}>
      <TemplatesAnimation showPage={Config.SHOW_PAGE} muted={muted} toggleMuted={toggleMuted} currentPage={currentPage} templates={pages} />
    </div>
  );
};

const mapStateToProps = (state: StateType) => {
  return {
    currentPage: state.appReducer.currentPage,
    muted: state.appReducer.muted,
  };
};

const mapDispatchToProps = {
  setMuted: appActions.setMuted,
  setCurrentPage: appActions.setCurrentPage,
};

export default connectWithDispatch(App, mapStateToProps, mapDispatchToProps);
